// media-library-image/media-library-image-ui.js

import { Plugin, icons } from 'ckeditor5/src/core';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { ContextualBalloon, clickOutsideHandler } from '@ckeditor/ckeditor5-ui';
import FormView from './media-library-image-view';

export default class MediaLibraryImageUI extends Plugin {

    init() {

        const editor = this.editor;

        // Create the balloon and the form view.
        this._balloon = this.editor.plugins.get( ContextualBalloon );
        this.formView = this._createFormView();

        // Register the button for this plugin
        editor.ui.componentFactory.add( 'mediaLibraryImage', () => {

            const button = new ButtonView();

            const iconImage = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-image" viewBox="0 0 16 16">\n' +
                '  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>\n' +
                '  <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>\n' +
                '</svg>';

            button.set( {
                label: 'Insert a Media Library image',
                icon: iconImage,
                tooltip: true
            });

            // Show the UI on button click.
            this.listenTo( button, 'execute', () => {
                this._showUI();
            } );

            return button;

        });

    }

    _createFormView() {

        const editor = this.editor;
        const formView = new FormView( editor.locale );

        // Execute the command after clicking the "Save" button.
        this.listenTo( formView, 'submit', () => {

            // Grab values from the abbreviation and title input fields.
            let alt = formView.altInput.fieldView.element.value;
            let width = formView.widthInput.fieldView.element.value;
            let url = formView.imageUrlHidden.fieldView.element.value;

            let attributes = { 'source' : {
                    src: url, alt: alt
                }
            };

            const imageUtils = this.editor.plugins.get( 'ImageUtils' );

            let selectedElement = editor.model.document.selection.getSelectedElement();

            if ( imageUtils.isImage( selectedElement ) ) {
                //console.log('isImage');
                editor.model.change( writer => {
                    writer.setAttribute( 'src', url, selectedElement );
                    writer.setAttribute( 'alt', alt, selectedElement );
                } );
                if (width !== '') {
                    editor.execute( 'resizeImage', { width: width } );
                }
            } else {
                //console.log('insertImage');
                editor.execute( 'insertImage', attributes );
                if (width !== '') {
                    editor.execute( 'resizeImage', { width: width } );
                }
            }

            // Hide the form view after submit.
            this._hideUI();

        } );

        // Hide the form view after clicking the "Cancel" button.
        this.listenTo( formView, 'cancel', () => {
            this._hideUI();
        } );

        // Open the image uploader in a new tab
        this.listenTo( formView, 'upload', () => {
            this._openImageUpload();
        } );

        // Refresh the list of images
        this.listenTo( formView, 'refresh', () => {
            this._refreshImageList();
        } );


        // Hide the form view when clicking outside the balloon.
        clickOutsideHandler( {
            emitter: formView,
            activator: () => this._balloon.visibleView === formView,
            contextElements: [ this._balloon.view.element ],
            callback: () => this._hideUI()
        } );

        return formView;
    }

    /**
     * Open the image uploader in a new tab
     * @private
     */
    _openImageUpload() {
        window.open('/manager/content/media/upload','_blank');
    }

    /**
     * Rebuilds the image list for after an image is added for example
     *
     * @private
     */
    _refreshImageList() {
        this._buildImagePicker($('.ck-media-library-image-panel'));
    }

    _showUI() {

        //const selection = this.editor.model.document.selection;

        this.formView.withArrow = false;

        this._balloon.add( {
            view: this.formView,
            balloonClassName: 'ck-media-library-image-picker ck-reset_all-excluded',
            withArrow: false,
            position: this._getBalloonPositionData(),
            singleViewMode: true,
            stackId: 'ckMediaLibrary'
        } );

        // Identify the selected element
        let $img = $('figure.ck-widget.ck-widget_selected img');
        let alt = '';
        let src = '';
        let width = '';
        if ($img.length) {
            alt = $img.attr('alt');
            src = $img.attr('src');
            width = $img.css('width');
            if (alt) {
                this.formView.altInput.fieldView.element.value = alt;
                this.formView.altInput.fieldView.set('isEmpty', false);
            }
            if (width) {
                this.formView.widthInput.fieldView.element.value = width;
                this.formView.widthInput.fieldView.set('isEmpty', false);
            }
            if (src) {
                this.formView.imageUrlHidden.fieldView.value = src;
            }
        }

        this.formView.formLoadingHidden.fieldView.value = true;

        this._buildImagePicker($('.ck-media-library-image-panel'));

    }

    _hideUI() {
        // Clear the input field values and reset the form.
        this.formView.altInput.fieldView.element.value = '';
        this.formView.imageIdHidden.fieldView.value = '';
        this.formView.imageUrlHidden.fieldView.value = '';
        this.formView.element.reset();

        this._balloon.remove( this.formView );

        // Focus the editing view after inserting the abbreviation so the user can start typing the content
        // right away and keep the editor focused.
        this.editor.editing.view.focus();
    }

    _getBalloonPositionData() {

        const view = this.editor.editing.view;
        const viewDocument = view.document;
        let target = null;

        // Set a target position by converting view selection range to DOM
        target = () => view.domConverter.viewRangeToDom( viewDocument.selection.getFirstRange() );

        return {
            target
        };

    }

    _buildImagePicker($target) {

        $('body').addClass('waiting');

        getCKEditorImagePickerWrapper()
            .then(
                (response) => {
                    // Insert the image picker wrapper
                    $target.html(response.data);
                    // Initialise the controls
                    initCKEditorImagePicker();
                    // Initialise the image select
                    this._initImageSelect($target);
                    // Clear the progress cursor
                    $('body').removeClass('waiting');
                }
            )["catch"](function (error) {
            // Clear the progress cursor
            $('body').removeClass('waiting');
        });

    }

    _initImageSelect($target) {

        // Make a local variable pointing to this, to avoid 'this' confusion inside the click function
        let obj = this;

        $target.find('.image-picker-image-wrapper').click(function() {

            // Set a class on the selected item
            $target.find('.image-picker-image-wrapper').removeClass('selected');
            $(this).addClass('selected');

            // Grab parameters from the selected item
            let alt = $(this).attr('data-image-alt') ? $(this).attr('data-image-alt') : '';
            let id = $(this).attr('data-image-id');
            let url = $(this).attr('data-image-url');

            // Set the field values - have to do it this way to ensure the change event is fired and the _updateIsEmpty method runs to handle label formatting
            obj.formView.imageIdHidden.fieldView.value = id;
            if (obj.formView.formLoadingHidden.fieldView.value === false) {
                obj.formView.imageUrlHidden.fieldView.value = url;
                obj.formView.altInput.fieldView.element.value = alt;
            }

        });

        if (obj.formView.imageUrlHidden.fieldView.value !== '') {
            // Find the selected image and trigger the click event to set its class
            $('.image-picker-image-wrapper[data-image-url=\'' + obj.formView.imageUrlHidden.fieldView.value + '\']').trigger('click');
        }

        obj.formView.formLoadingHidden.fieldView.value = false;

    }


}
